import React, { useEffect, useState, }  from 'react';
import { useSelector,useDispatch } from 'react-redux';
import { GetUrl, GetMaintenanceUrl, formatNumber, CTicksToDateString } from '../Utility.js';
import { useNavigate } from 'react-router-dom';

function RechargePointModal({ isOpen, onClose}) {
    const state = useSelector((state)=>state);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [RechargePointString, setRechargePointString] = useState("0");
    const [RechargePoint, setRechargePoint] = useState(0);
    const [StartLogIndex, setStartLogIndex] = useState(1);
    const [IsRechargePointView, setIsRechargePointView] = useState(true);
    const [TotalLogCount, setTotalLogCount] = useState(-1);
    const [selectedIndex, setSelectedIndex] = useState(0);

    const rechargeOptions = [
        { points: "30,000P", price: "45,000원" },
        { points: "90,000P", price: "130,000원", discount: "5,000원 Off" },
        { points: "150,000P", price: "200,000원", discount: "25,000원 Off" },
    ];

    const product_Ids = [
        "fit.30000.point",
        "fit.90000.point",
        "fit.150000.point",
    ];

    useEffect(() => {

        const purchaseMsg = (event) => {
            try
            {  
                const data = JSON.parse(event.data);
                if(data.msg === "purchase")
                {
                    if (data.status === "success") {
                        console.log("결제 성공!", data.purchase);
                        PointPurchase(data.purchase, data.purchase_token);
                        // 결제 성공 처리
                    } else if (data.status === "error") {
                        // 결제 실패 처리
                        alert('결제 실패 ' + data.error);  
                        dispatch({type:'Response'});
                    }
                }
            }
            catch(error)
            {
            }
        }

        window.addEventListener("message", purchaseMsg);
        document.addEventListener("message", purchaseMsg);
    
        return () => {
            window.removeEventListener("message", purchaseMsg);
            document.removeEventListener("message", purchaseMsg);
        };
     }, []);

    function AddRechargePoint(point) 
    {
        setRechargePoint(RechargePoint + point);
        setRechargePointString(formatNumber(RechargePoint + point));
    }

    function ResetRechargePoint()
    {
        setRechargePoint(0);
        setRechargePointString(formatNumber(0));
    }

    const PointRecharge = async () => 
        {
            try
            {
                if(RechargePoint === 0)
                {
                    alert('포인트 충전 0원 보다 큰 금액만 가능합니다.');  
                    return;
                }

                if(state.Request === 1)
                {
                    return;
                }
    
                var secretkey = sessionStorage.getItem("secret_key");
                if(secretkey === null)
                {
                  alert('유저 정보 만료(다시 로그인 해주세요)');  
                  navigate('/login'); // 로그인 성공 시 메인 페이지로 이동  
                  return;    
                }
                
                dispatch({type:'Request'});
                const response = await fetch(GetUrl() + 'PointRecharge/PointRecharge', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ secret_key : secretkey, recharge_point : RechargePoint }),
                });
    
                if (response.ok) {
                    const data = await response.json();
                    if(data.result === 0)
                    {
                        alert(RechargePoint + '원 충전 신청 하였습니다.');  
                    }
                    else if(data.result === 3 ||
                            data.result === 1)
                    {
                        alert('유저 정보 만료(다시 로그인 해주세요)');  
                        navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                    }
                    else if(data.result === 21) // 점검 중
                    {
                      var startTime = CTicksToDateString(data.start_time);
                      var endTime = CTicksToDateString(data.end_time);
        
                      var message = `${startTime} ~ ${endTime} 점검 중 입니다. 잠시후에 이용해 주세요`;
                      alert(message);  
                      navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                    }
                } 
                else
                {
                    alert('Network Fail');
                }
    
                dispatch({type:'Response'});
            }
            catch(error)
            {
                alert('Network Fail');
                dispatch({type:'Response'});
                console.error(error);
            }
        };

    const PointPurchase = async (product_id, product_token) => 
        {
            try
            {    
                var secretkey = sessionStorage.getItem("secret_key");
                if(secretkey === null)
                {
                  alert('유저 정보 만료(다시 로그인 해주세요)');  
                  navigate('/login'); // 로그인 성공 시 메인 페이지로 이동  
                  return;    
                }
                
                dispatch({type:'Request'});
                const response = await fetch(GetUrl() + 'PurchaseGoogle/PurchaseGoogle', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ secret_key : secretkey, product_id : product_id, purchase_token: product_token}),
                });
    
                if (response.ok) {
                    const data = await response.json();
                    if(data.result === 0)
                    {
                        alert(data.recharge_point + 'P 충전 하였습니다.');  
                        dispatch({type:'UpdatePoint', Point:data.cur_point});
                    }
                    else if(data.result === 3 ||
                            data.result === 1)
                    {
                        alert('유저 정보 만료(다시 로그인 해주세요)');  
                        navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                    }
                    else if(data.result === 21) // 점검 중
                    {
                      var startTime = CTicksToDateString(data.start_time);
                      var endTime = CTicksToDateString(data.end_time);
        
                      var message = `${startTime} ~ ${endTime} 점검 중 입니다. 잠시후에 이용해 주세요`;
                      alert(message);  
                      navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                    }
                    else if(data.result === 19 || data.result === 24)
                    {
                        var message = `구매 실패 관리자에 문의 바랍니다.(${data.result})`;

                        alert(message);  
                        navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                    }
                } 
                else
                {
                    alert('Network Fail');
                }
    
                dispatch({type:'Response'});
            }
            catch(error)
            {
                alert('Network Fail');
                dispatch({type:'Response'});
                console.error(error);
            }
        };


    function LogStartIndexClick(index)
    {
        if(StartLogIndex === index)
        {
            return;
        }

        if(TotalLogCount === -1)
        {
            return;
        }

        var convertIndex = Math.ceil(TotalLogCount / 10);
        if(convertIndex < index)
        {
            return;
        }

        setStartLogIndex(index);
        RequestPointRechargeLog(index);
    }

    function GetLogTime(index)
    {
        if(state.recharge_point_log_array === undefined || state.recharge_point_log_array.length <= index)
        {
            return'';
        }

        return CTicksToDateString(state.recharge_point_log_array[index].createattime_ticks);
    }

    function GetLogPoint(index)
    {       
        if(state.recharge_point_log_array === undefined || state.recharge_point_log_array.length <= index)
        {
            return'';
        }

        return formatNumber(state.recharge_point_log_array[index].money) + "P";
    }

    function GetLogState(index)
    {
        if(state.recharge_point_log_array === undefined || state.recharge_point_log_array.length <= index)
        {
            return'';
        }

        if(state.recharge_point_log_array[index].state === 0)
        {
            return '승인대기';
        }
        else if(state.recharge_point_log_array[index].state === 1)
        {
            return '승인';
        }
        else
        {
            return '거절';
        }
    }

    const Close = () =>{
        if(state.Request === 1)
        {
            return;
        }

        onClose();

        setRechargePointString("0");
        setRechargePoint(0);
        setStartLogIndex(1);
        setIsRechargePointView(true);
        setTotalLogCount(-1);
        setSelectedIndex(0);
        dispatch({type:'UpdateRechargePointModalLog', Log:[]});    
    }

    function WatingMsg()
    {
        alert("준비 중 입니다.");
    }

    function ChangeView(view)
    {
        if(IsRechargePointView === view)
        {
            return;
        }

        setIsRechargePointView(view);
        if(view === false)
        {
            setTotalLogCount(-1);
            setRechargePointString("0");
            setRechargePoint(0);
            setStartLogIndex(1);  
            RequestPointRechargeLog(1);
        }
    }

    const RequestPointRechargeLog = async (startIndex) => 
    {
        try
        {
            if(state.Request === 1)
            {
                return;
            }

            dispatch({type:'UpdateRechargePointModalLog', Log:[]});           

            var secretkey = sessionStorage.getItem("secret_key");
            if(secretkey === null)
            {
              alert('유저 정보 만료(다시 로그인 해주세요)');  
              navigate('/login'); // 로그인 성공 시 메인 페이지로 이동  
              return;    
            }
            
            dispatch({type:'Request'});
            const response = await fetch(GetUrl() + 'SearchRechargePoint/SearchRechargePoint', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ secret_key : secretkey, start_index : startIndex - 1, content_count:10 }),
            });

            if (response.ok) {
                const data = await response.json();
                if(data.result === 0)
                {
                    setTotalLogCount(data.total_count);
                    dispatch({type:'UpdateRechargePointModalLog', Log:data.recharge_point_datas});
                }
                else if(data.result === 3 ||
                        data.result === 1)
                {
                    alert('유저 정보 만료(다시 로그인 해주세요)');  
                    navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                }
                else if(data.result === 21) // 점검 중
                {
                  var startTime = CTicksToDateString(data.start_time);
                  var endTime = CTicksToDateString(data.end_time);
    
                  var message = `${startTime} ~ ${endTime} 점검 중 입니다. 잠시후에 이용해 주세요`;
                  alert(message);  
                  navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                }
            } 
            else
            {
                alert('Network Fail');
            }

            dispatch({type:'Response'});
        }
        catch(error)
        {
            alert('Network Fail');
            dispatch({type:'Response'});
            console.error(error);
        }
    };

    function PurchaseProduct() {

        if(state.Request === 1)
        {
            return;
        }
        dispatch({type:'Request'});
        if (window.ReactNativeWebView) {
          window.ReactNativeWebView.postMessage(JSON.stringify({ msg:'purchase', data:product_Ids[selectedIndex] }));
        } else {
          console.log("React Native WebView가 감지되지 않았습니다.");
        }
      }

    function GetStore()
    {
        if(window.ReactNativeWebView)
        {
            return true;
        }

        return false;
    }

    if (!isOpen) return null;

    return (
        <div className="recharge-point-modal-overlay" onClick={Close}>
            <div className='recharge-point-modal-button-box' onClick={(e) => e.stopPropagation()}>
                <div className="point-recharge-modal" style={{backgroundColor: IsRechargePointView === true ? "RGB(255,255,255)" : "RGB(143,143,143)"}} onClick={() => ChangeView(true)}><h2>포인트 충전</h2></div>
                <div className="point-rechargg-log-modal" style={{backgroundColor: IsRechargePointView === true ? "RGB(143,143,143)" : "RGB(255,255,255)"}} onClick={() => ChangeView(false)}><h2>충전 내역</h2></div>
                <button className="recharge-point-modal-close" onClick={Close}>
                    <h2>X</h2>
                </button>
            </div>
            <div className="recharge-point-modal-content" onClick={(e) => e.stopPropagation()}>
                <div className='point-recharge-box' style={{ display: IsRechargePointView === true ? 'block' : 'none' }}>
                    {GetStore() === true &&
                    <>
                    <div className='point-recharge-body'>
                        <div className='point-recharge-point-title'>포인트 구매</div>
                        <div className='point-recharge-point'>
                            
                        <ul>
                            {rechargeOptions.map((option, index) => (
                                <li key={index} onClick={() => setSelectedIndex(index)} className="point-recharge-option">
                                    <div className='point-recharge-info-bankbook-circle'>
                                        {selectedIndex === index && <div className='point-recharge-info-bankbook-circle2'></div>}
                                    </div>
                                    {option.points} <p>→</p><p><b>{option.price}</b><span>{option.discount}</span></p>
                                </li>
                            ))}
                        </ul>
                            
                        </div>
                    </div>
                    <div className='point-recharge-button-blue' onClick={() => PurchaseProduct()}><h2>구매하기</h2></div>
                    </>
                    }
                    {GetStore() === false &&
                    <>
                    <div className='point-recharge-gorup'>
                        <div className='point-recharge-gorup-title'><h2>충전 금액 </h2></div>
                        <div className='point-recharge-gorup-form'><h2>{RechargePointString}원</h2></div>
                    </div>
                    <div className='point-recharge-sub-button-box'>
                        <div className='point-recharge-sub-button' onClick={() => AddRechargePoint(10000)}><h2>10,000원</h2></div>
                        <div className='point-recharge-sub-button' onClick={() => AddRechargePoint(30000)}><h2>30,000원</h2></div>
                        <div className='point-recharge-sub-button' onClick={() => AddRechargePoint(50000)}><h2>50,000원</h2></div>
                        <div className='point-recharge-sub-button' onClick={() => AddRechargePoint(100000)}><h2>100,000원</h2></div>
                        <div className='point-recharge-sub-button' onClick={() => ResetRechargePoint()}><h2>리셋</h2></div>
                    </div>
                    <div className='point-recharge-line'></div>
                    <div className='point-recharge-info'>
                        <div className='point-recharge-info-bankbook'>
                            <div className='point-recharge-info-bankbook-circle'>
                                <div className='point-recharge-info-bankbook-circle2'></div>                                                             
                            </div>
                            <div className='bankbook-text'>
                            <h2>무통장 입금(입금시 입금자 명에 사용 닉네임 기입)</h2>
                            <h3>은형명 : 하나은행</h3>
                            <h3>계좌번호 : 293-910030-29004</h3>
                            <h3>예금주 : 주식회사 아르제닉스</h3>  
                            </div>

                        </div>
                        <div className='point-recharge-info-credit-card'>
                            <div className='point-recharge-info-credit-card-circle' onClick={() => WatingMsg()}>                                
                            </div>
                            <div className='bankbook-text'>
                            <h2>카드 결제</h2>
                            </div>
                        </div>
                    </div>
                    <div className='point-recharge-button' onClick={() => PointRecharge()}><h2>충전하기</h2></div>
                    </>
                    }
                </div>
                <div className='point-recharge-log-box' style={{ display: IsRechargePointView === true ? 'none' : 'block'   }}>
                    <div className='point-recharge-log-box-table'>
                        <table>
                        <thead>
                            <tr>
                                <th style={{width:"600px"}}>충전 일시</th>
                                <th style={{width:"200px"}}>충전 금액</th>
                                <th style={{width:"200px"}}>상태</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Array.from({length:10}).map((_, index)=>(
                                <tr key={index}>
                                    <td style={{width:"600px", textAlign:"center"}}>{GetLogTime(index)}</td>
                                    <td style={{width:"200px", textAlign:"right"}}>{GetLogPoint(index)}</td>
                                    <td style={{width:"200px", textAlign:"center"}}>{GetLogState(index)}</td>
                                </tr>
                            ))}
                        </tbody>
                        </table>
                    </div>
                    <div className='point-recharge-log-count-box'>
                        <div className='point-recharge-log-count' onClick={() => LogStartIndexClick(1)}><h2 style={{fontWeight: StartLogIndex === 1 ? "bold" : "normal"}}>1</h2></div>
                        <div className='point-recharge-log-count' onClick={() => LogStartIndexClick(2)}><h2 style={{fontWeight: StartLogIndex === 2 ? "bold" : "normal"}}>2</h2></div>
                        <div className='point-recharge-log-count' onClick={() => LogStartIndexClick(3)}><h2 style={{fontWeight: StartLogIndex === 3 ? "bold" : "normal"}}>3</h2></div>
                        <div className='point-recharge-log-count' onClick={() => LogStartIndexClick(4)}><h2 style={{fontWeight: StartLogIndex === 4 ? "bold" : "normal"}}>4</h2></div>
                        <div className='point-recharge-log-count' onClick={() => LogStartIndexClick(5)}><h2 style={{fontWeight: StartLogIndex === 5 ? "bold" : "normal"}}>5</h2></div>
                        <div className='point-recharge-log-count' onClick={() => LogStartIndexClick(6)}><h2 style={{fontWeight: StartLogIndex === 6 ? "bold" : "normal"}}>6</h2></div>
                        <div className='point-recharge-log-count' onClick={() => LogStartIndexClick(7)}><h2 style={{fontWeight: StartLogIndex === 7 ? "bold" : "normal"}}>7</h2></div>
                        <div className='point-recharge-log-count' onClick={() => LogStartIndexClick(8)}><h2 style={{fontWeight: StartLogIndex === 8 ? "bold" : "normal"}}>8</h2></div>
                        <div className='point-recharge-log-count' onClick={() => LogStartIndexClick(9)}><h2 style={{fontWeight: StartLogIndex === 9 ? "bold" : "normal"}}>9</h2></div>
                        <div className='point-recharge-log-count' onClick={() => LogStartIndexClick(10)}><h2 style={{fontWeight: StartLogIndex === 10 ? "bold" : "normal"}}>10</h2></div>

                    </div>
                </div>
            </div>
        </div>
    );
}

export default RechargePointModal;